import { defineMessages } from 'react-intl'

export default defineMessages({
  defaultLabel: {
    id: 'ImageLibrary.defaultLabel',
    defaultMessage: 'Image'
  },
  requiredIcon: {
    id: 'ImageLibrary.requiredIcon',
    defaultMessage: '*'
  },
  requiredError: {
    id: 'ImageLibrary.required',
    defaultMessage: '{label} is required'
  },
  uploading: {
    id: 'ImageLibrary.uploading',
    defaultMessage: 'Image upload in progress. Please wait until complete.'
  },
  uploadFailure: {
    id: 'ImageLibrary.uploadFailure',
    defaultMessage: 'An issue occurred while uploading.'
  },
  cancel: {
    id: 'ImageLibrary.cancel',
    defaultMessage: 'Cancel'
  },
  delete: {
    id: 'ImageLibraryModal.delete',
    defaultMessage: 'Delete'
  },
  save: {
    id: 'ImageLibraryModal.save',
    defaultMessage: 'Save'
  },
  preview: {
    id: 'ImageLibraryModal.preview',
    defaultMessage: 'Preview'
  },
  tryAgain: {
    id: 'ImageLibrary.tryAgain',
    defaultMessage: 'Try again'
  },
  invalidFileType: {
    id: 'ImageLibrary.invalidFileType',
    defaultMessage: 'Please enter a valid image URL ({types})'
  },
  invalidUploadFileType: {
    id: 'ImageLibrary.invalidUploadFileType',
    defaultMessage: 'Please upload a {types} image'
  },
  reset: {
    id: 'ImageLibrary.reset',
    defaultMessage: 'Reset'
  },
  dropZoneUpload: {
    id: 'ImageLibrary.uploadImage',
    defaultMessage: 'Upload image'
  },
  dropZoneOr: {
    id: 'ImageLibrary.or',
    defaultMessage: 'or'
  },
  viewLibrary: {
    id: 'ImageLibrary.openLibrary',
    defaultMessage: 'view library'
  },
  imageUrl: {
    id: 'ImageLibrary.image',
    defaultMessage: 'Image URL'
  },
  useImageUrl: {
    id: 'ImageLibrary.toggleUrl',
    defaultMessage: 'Use Image URL'
  },
  toggleUpload: {
    id: 'ImageLibrary.toggleUpload',
    defaultMessage: 'Use Image Upload'
  },
  invalidUrl: {
    id: 'ImageLibrary.validationError',
    defaultMessage: 'Invalid image URL'
  },
  remove: {
    id: 'ImageLibrary.delete',
    defaultMessage: 'Remove'
  },
  galleryTitle: {
    id: 'ImageLibraryModal.title',
    defaultMessage: 'Image Library'
  },
  galleryLoadError: {
    id: 'ImageLibraryModal.error',
    defaultMessage: 'Error loading images'
  },
  galleryUpload: {
    id: 'ImageLibraryModal.upload',
    defaultMessage: 'Upload'
  },
  uploadError: {
    id: 'ImageLibraryModal.uploadError',
    defaultMessage: 'Upload failed'
  },
  retry: {
    id: 'ImageLibraryModal.retry',
    defaultMessage: 'Retry'
  },
  confirmDeleteTitle: {
    id: 'ImageLibraryModal.confirmDeleteTitle',
    defaultMessage: 'Are you sure?'
  },
  confirmDeleteSub: {
    id: 'ImageLibraryModal.confirmDeleteSub',
    defaultMessage: 'Are you sure you want to delete this image?'
  },
  confirmButtonMessage: {
    id: 'ImageLibraryModal.confirmButtonMessage',
    defaultMessage: 'Yes, delete'
  },
  cancelButtonMessage: {
    id: 'ImageLibraryModal.cancelButtonMessage',
    defaultMessage: 'No, keep image'
  }
})
